import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Rating, FormControl, Typography } from '@mui/material';
import { StarRateRounded } from '@mui/icons-material';

interface FormStarRatingProps {
  name: string;
  label: string | JSX.Element;
  defaultRate?: number;
  onChange?: (value: number) => void;
}

const defaultProps = {
  onChange: undefined,
  defaultRate: 0,
};

export const FormStarRating: FC<FormStarRatingProps> = ({ name, label, onChange, defaultRate }) => {
  const { control } = useFormContext();

  return (
    <FormControl component="fieldset">
      <Typography component="article">{label}</Typography>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange: onRateChange, value } }) => {
          return (
            <Rating
              name={name}
              defaultValue={defaultRate || 0}
              precision={1}
              value={value || defaultRate}
              onChange={(e, newValue) => {
                onRateChange(newValue || 0);
                if (onChange) onChange(newValue || 0);
              }}
              size="large"
              icon={<StarRateRounded style={{ fill: 'var(--color-second-order-accent)' }} fontSize="inherit" />}
              emptyIcon={<StarRateRounded style={{ fill: 'var(--color-secondary-items)' }} fontSize="inherit" />}
            />
          );
        }}
      />
    </FormControl>
  );
};

FormStarRating.defaultProps = defaultProps;
